import React, { useState } from "react";
import PortafolioList from "./PortafolioList";
import LoadSimple from "../../LoadSimple";
import { capitalizeFirstLetter } from "../../../utils/utils";
import { lang } from "../../generales/traduction";
const TablePortafolio = ({
  pageActual,
  limitList,startLimit,
  devices,
  dataList,
  cisSelected,
  setCisSelected,
  registerIsValid,
  searchResults,
  setSearchResults,
  onSearch,
  dataUsers,
  setDataUsers,
  searchTerm,
  setSearchTerm,
  server,
  setRegisterIsValid,
  setData,
  setLoading,
  setError,
  handleChangEdit,
  languaje,
  mode
}) => {
  return (
    <div className="cont-table-portafolio">
      <div className={"head-table-portafolio"+mode}>
      <div className="compact-head-table-portafolio">
        <div className="field-head-table-mantenimiento field-medium">Agency ID</div>
        <div className="field-head-table-mantenimiento field-larger"style={{width:'17%'}}>{capitalizeFirstLetter(lang[languaje]['nombre'])}</div>
        <div className="field-head-table-mantenimiento field-larger" >Short name </div>
        <div className="field-head-table-mantenimiento field-larger" >color</div>
        <div className="field-head-table-mantenimiento field-larger">{capitalizeFirstLetter(lang[languaje]['icono'])}</div>
        <div className="field-head-table-mantenimiento field-larger">{capitalizeFirstLetter(lang[languaje]['previewIcon'])}</div>
        <div className="field-head-table-mantenimiento field-larger">{capitalizeFirstLetter(lang[languaje]['previewLayer'])}</div>
        {/* <div className="field-head-table-mantenimiento field-larger">{capitalizeFirstLetter(lang[languaje]['acciones'])}</div> */}
      </div>
      </div>
      <div className="body-table-portafolio">
        {registerIsValid ? (
          <div className="cont-load-user-list">
            <LoadSimple></LoadSimple>
          </div>
        ) : (
          <PortafolioList
            pageActual={pageActual}
             limitList={limitList} startLimit={startLimit}
            dataList={dataList}
            devices={devices}
            cisSelected={cisSelected}
            setCisSelected={setCisSelected}
            searchResults={searchResults}
            setSearchResults={setSearchResults}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            dataUsers={dataUsers}
            setDataUsers={setDataUsers}
            server={server}
            setRegisterIsValid={setRegisterIsValid}
            setData={setData}
            setLoading={setLoading}
            setError={setError}
            handleChangEdit={handleChangEdit}
            languaje={languaje}
            mode={mode}
          ></PortafolioList>
        )}
      </div>
    </div>
  );
};

export default TablePortafolio;
